var _templateObject = _taggedTemplateLiteralLoose(["font-size: 64px"], ["font-size: 64px"]),
    _templateObject2 = _taggedTemplateLiteralLoose(["font-size: 36px"], ["font-size: 36px"]),
    _templateObject3 = _taggedTemplateLiteralLoose(["font-size: 20px"], ["font-size: 20px"]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import commonProps, { omitCommonProps } from "./_commonProps";
import Text from "./Text";
import Divider from "./Divider";
import { media } from "../index";

var UnstyledHeading = function UnstyledHeading(_ref) {
  var as = _ref.as,
      props = _objectWithoutProperties(_ref, ["as"]);

  var WrappingComponent = as;
  return React.createElement(
    WrappingComponent,
    omitCommonProps(props),
    props.children,
    props.dividing ? React.createElement(Divider, {
      color: props.color,
      position: props.center ? "center" : "left"
    }) : ""
  );
};

var Heading = styled(UnstyledHeading).withConfig({
  displayName: "Heading",
  componentId: "sc-1xl9o36-0"
})(["letter-spacing:0.2px;line-height:1.35em;&&{text-rendering:geometricPrecision;}", ";", ";", ";& + ", "{margin-top:0;}& + ", "{margin-top:-0.5em;}", ";", ";"], function (props) {
  return props.as === "h1" && css(["font-size:42px;font-weight:600;", ";"], media.desktop(_templateObject));
}, function (props) {
  return props.as === "h2" && css(["font-size:32px;font-weight:600;", ";"], media.desktop(_templateObject2));
}, function (props) {
  return props.as === "h3" && css(["font-size:22px;font-weight:bold;margin-bottom:0.5em;", ";"], media.desktop(_templateObject3));
}, Text, Divider, function (props) {
  return props.sticky && css(["margin-bottom:0;"]);
}, commonProps);

Heading.propTypes = {
  as: PropTypes.string.isRequired,
  color: PropTypes.string,
  center: PropTypes.bool
};

Heading.defaultProps = {
  as: "h1",
  color: "black",
  center: false
};

Heading.Sub = styled.div.withConfig({
  displayName: "Heading__Sub",
  componentId: "sc-1xl9o36-1"
})(["font-size:60%;font-weight:normal;"]);

export default Heading;